import React from 'react';
import styled from 'styled-components';
import { Fragment } from 'react';
import LicenceSelectorChip from './licenceSelectorChip';
import LicenceSelectorInput from './licenceSelectorInput';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';
import Scrollbars from 'react-custom-scrollbars';
import InformationIcon from '../atoms/information-icon';
import LicenceSelectorUpdateList from './software_licence/licence_selector_update_list';
import { answerIsActive } from '../features/screens/licence_selector_screen/utils';
import { PRIMARY_COLOR } from '../color-constants';
import LicenceSelectorCheckbox from './licenceSelectorCheckbox';
import LicenceSelectorCheckCardV2 from './licenceSelectorCheckcardV2';
import LicenceSelectorImageCheckCard from './licenceSelectorImageCheckcard';
import LicenceSelectorToggle from './licenceSelectorToggle';

const AnswerWrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.direction === 'row' ? 'row' : 'column'};
  flex-wrap: wrap;
  margin-top: 20px;
  margin-right: -10px;
  max-width: 100%;
  box-sizing: border-box;
  @media (max-width: 800px) {
    margin-right: 0px;
  }
`;

const ChipWrapper = styled.div`
`;

const CheckboxWrapper = styled.div`
  margin: 4px;
`;

const CheckcardWrapper = styled.div`
  display: flex;
  flex: 0 0 calc(100% - 10px);
  margin-bottom: 10px;
  padding-left: 2px;
  margin-right: 10px;

  ${props => props.$direction === 'row' ? `
    flex: 0 0 calc(50% - 12px);
    max-width: 50%;
  ` : ''}

  @media (max-width: 800px) {
    flex: 0 0 calc(100% - 10px);
    max-width: unset;
  }
`;

const ImageCheckcardWrapper = styled.div`
  display: flex;
  flex: 0 1 calc(100% - 12px);
  margin-right: 10px;
  margin-bottom: 10px;
  padding-left: 2px;

  ${props => props.$direction === 'row' ? `
    flex: 0 0 calc(50% - 12px);
    max-width: 50%;
    margin-right: 10px;
  ` : ''}

  @media (max-width: 800px) {
    flex: 0 0 calc(100% - 10px);
    max-width: unset;
  }
`;

const NumberWrapper = styled.div`
  display: flex;
  margin-right: 10px;
`;

const QuestionWrapper = styled.div`
  margin-bottom: 10px;
`;

const TitleQuestionWrapper = styled.div`
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

const SubTitle = styled.span`
  display: flex;
  color: #626469;
  font-size: 12px;
  font-weight: 400;
  margin-top: 10px;
  white-space: pre-wrap;
`;

const MandatoryStar = styled.span`
  color: #ED2B00;
  font-size: 14px;
  margin-left: 5px;
`;

const QuestionDetailModal = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(51,51,51, 0.5);
  justify-content: center;
  align-items: flex-end;
  z-index: 410;
`;

const QuestionDetailContainer = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  border-radius: 10px;
`;

const QuestionDetailHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const QuestionDetailModalTitle = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const QuestionDetailContent = styled.div`
  display: flex;
  flex: 1;
  padding: 10px 20px;
  border-top: 2px solid #cccc;
  background-color: #f4f4f4;
`;

const HintIcon = styled.span`
  display: inline-block;
  margin-left: 4px;
  color: #6D6F75;
  cursor: pointer;
`;

const ModalHintLabel = styled.span`
  white-space: pre-wrap;
`;

const ModalHintWrapper = styled.div`
  margin-bottom: 10px;
`;

const ModalAnswerItemTitle = styled.span`
  font-weight: bold;
`;

const CHIP = "chip";
const TOGGLE = "toggle";
const CHECKCARD = "checkcard";
const IMAGECHECKCARD= "imageCheckcard";
const CHECKBOX = "checkbox";
const NUMBER = "number";
const LIST = "list";

class LicenceSelectorQuestion extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      questionDetailOpen: false
    };
  }
  renderQuestionDetail = (question, activeAnswers) => {
    return (<QuestionDetailModal>
      <QuestionDetailContainer>
        <QuestionDetailHeader>
          <QuestionDetailModalTitle>{I10n.getOrDefault(`screen.licence_selector.modal.question.name.${question.labelKey}`, question.name)}</QuestionDetailModalTitle>
          <CloseIcon onClick={(e) => {
            e.preventDefault();
            this.setState({ questionDetailOpen: false })
          }}>
            <MsxIcons name="close"></MsxIcons>
          </CloseIcon>
        </QuestionDetailHeader>
        <QuestionDetailContent>
          <Scrollbars>
            {question.hint && <ModalHintWrapper><ModalHintLabel>{I10n.getOrDefault(`screen.licence_selector.modal.question.hint.${question.key}`, question.hint)}</ModalHintLabel></ModalHintWrapper>}
            {(activeAnswers || []).filter((answer) => answer.type === CHIP).filter((answer) => answer.hint != null).map((answer, idx) => {
              return (
                <ModalHintWrapper key={idx}>
                  <ModalAnswerItemTitle>{`${I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)}: `}</ModalAnswerItemTitle>
                  <ModalHintLabel>{I10n.getOrDefault(`screen.licence_selector.modal.answer.hint.${answer.labelKey}`, answer.hint)}</ModalHintLabel>
                </ModalHintWrapper>
              );
            })}
          </Scrollbars>
        </QuestionDetailContent>
      </QuestionDetailContainer>
    </QuestionDetailModal>);
  }

  renderAnswer = (answer, question) => {
    const { userAnswers, setAnswer, clearAnswers, softwareLicencesMap, activeQuestions } = this.props;
    let component;

    switch (answer.type) {
      case CHIP:
        component = (
          <ChipWrapper>
            <LicenceSelectorChip answer={answer} userAnswers={userAnswers} setAnswer={(key, value) => setAnswer(key, value, answer)} />
          </ChipWrapper>
        );
        break;
      case TOGGLE:
        component = (
          <ChipWrapper>
            <LicenceSelectorToggle answer={answer} userAnswers={userAnswers} setAnswer={(key, value) => setAnswer(key, value, answer)} />
          </ChipWrapper>
        );
        break;
      case CHECKCARD:
        component = (
          <CheckcardWrapper $direction={question.direction}>
            <LicenceSelectorCheckCardV2
              answer={answer}
              activeQuestions={activeQuestions}
              userAnswers={userAnswers}
              setAnswer={(key, value) => setAnswer(key, value, answer)}
              clearAnswers={clearAnswers}
              softwareLicencesMap={this.props.softwareLicencesMap}
            />
          </CheckcardWrapper>
        );
        break;
      case IMAGECHECKCARD:
        component = (
          <ImageCheckcardWrapper $direction={question.direction}>
            <LicenceSelectorImageCheckCard
              answer={answer}
              activeQuestions={activeQuestions}
              userAnswers={userAnswers}
              setAnswer={(key, value) => setAnswer(key, value, answer)}
              clearAnswers={clearAnswers}
              softwareLicencesMap={this.props.softwareLicencesMap}
            />
          </ImageCheckcardWrapper>
        );
        break;
      case CHECKBOX:
        component = (
          <CheckboxWrapper>
            <LicenceSelectorCheckbox answer={answer} userAnswers={userAnswers} setAnswer={(key, value) => setAnswer(key, value, answer)}/>
          </CheckboxWrapper>
        );
        break;
      case NUMBER:
        component = (
          <NumberWrapper>
            <LicenceSelectorInput
              answer={answer}
              userAnswers={userAnswers}
              setAnswer={(key, value) => setAnswer(key, value, answer)}
              matchReference={question.matchReference}
              softwareLicencesMap={softwareLicencesMap}
              showMandatoryOnInput={question.name == null && question.mandatory === true}
            />
          </NumberWrapper>
        );
        break;
      case LIST:
        component = (
          <LicenceSelectorUpdateList answer={answer} userAnswers={userAnswers} setAnswer={(key, value) => setAnswer(key, value, answer)} clearAnswers={clearAnswers}></LicenceSelectorUpdateList>
        );
        break;
      default:
        break;
    }

    return component;
  }


  getActiveAnswers = (userAnswers) => {
    const activeAnswers = [];

    for (const answer of this.props.question.answers) {
      if (answerIsActive(answer, userAnswers) || answer.disableOnly) {
        activeAnswers.push(answer);
      }
    }

    return activeAnswers;
  }

  componentDidMount() {
    this.selectSingleActiveAnswer();
  }

  componentDidUpdate() {
    this.selectSingleActiveAnswer();
  }

  selectSingleActiveAnswer = () => {
    const { userAnswers, setAnswer } = this.props;
    const activeAnswers = this.getActiveAnswers(userAnswers);

    if (this.props.question.mandatory && activeAnswers.length === 1 && activeAnswers[0].type === "chip") {
      const isAlreadySelected = userAnswers[activeAnswers[0].criteria] === activeAnswers[0].value;
      if (!isAlreadySelected) {
        setAnswer(activeAnswers[0].criteria, activeAnswers[0].value, activeAnswers[0]);
      }
    }
  }

  hasHint(question, activeAnswers) {
    return question.hint != null || (activeAnswers || [])
      .filter((answer) => answer.type === CHIP)
      .some((answer) => answer.hint != null);
  }

  shouldHideQuestion = () => {
    const { question, userAnswers } = this.props;
    const activeAnswers = this.getActiveAnswers(userAnswers);
    if (
      question.mandatory &&
      activeAnswers.length === 1 &&
      activeAnswers[0].type === "chip" &&
      userAnswers[activeAnswers[0].criteria] === activeAnswers[0].value
    ) {
      return true;
    }
    return false;
  }

  render() {
    const { question, userAnswers } = this.props;

    if (this.shouldHideQuestion()) {
      return null;
    }

    const activeAnswers = this.getActiveAnswers(userAnswers);

    return (
      <QuestionWrapper id={question.key}>
        <TitleQuestionWrapper>
          {question.name ? <>
            {I10n.getOrDefault(`screen.licence_selector.modal.question.name.${question.labelKey}`, question.name)}
            {question.mandatory && <MandatoryStar>*</MandatoryStar>}
          </> : <></>}
          {this.hasHint(question, activeAnswers) && <HintIcon onClick={() => { this.setState({ questionDetailOpen: true }) }}>
            <InformationIcon size="small"></InformationIcon>
          </HintIcon>}
        </TitleQuestionWrapper>
        {question.subtext && <SubTitle>{I10n.getOrDefault(`screen.licence_selector.modal.question.subtext.${question.labelKey}`, question.subtext)}</SubTitle>}
        <AnswerWrapper direction={question.direction}>
          {activeAnswers.map((answer, idx) => {
            return (
              <Fragment key={idx}>{this.renderAnswer(answer, question)}</Fragment>
            );
          })}
        </AnswerWrapper>
        {this.state.questionDetailOpen && this.hasHint(question, activeAnswers) && this.renderQuestionDetail(question, activeAnswers)}
      </QuestionWrapper>
    );
  }
}

export default LicenceSelectorQuestion;
